import DayPicker from 'react-day-picker';
import MomentLocaleUtils from 'react-day-picker/moment';
import './DayPicker.css';

export default DayPicker;
export { MomentLocaleUtils };
